import { render, staticRenderFns } from "./SignupPurchase.vue?vue&type=template&id=434c5120&"
import script from "./SignupPurchase.vue?vue&type=script&lang=js&"
export * from "./SignupPurchase.vue?vue&type=script&lang=js&"
import style0 from "./SignupPurchase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports